<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <DataTable
      :data="suscripcions"
      :columns="columnas"
      idField="idSuscripcion"
      mensajeVacio="No hay suscripciones registradas."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idSuscripcion)"
      @view="row => abrirEditar(row.idSuscripcion)"
      @delete="row => deleteSuscripcion(row.idSuscripcion)"
    >
      <!-- Búsqueda por nombre de usuario -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar usuario..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- Fechas formateadas -->
      <template #cell-fechaReg="{ row }">
        {{ getFormattedDate(row.fechaReg) }}
      </template>
      <template #cell-fechaDesde="{ row }">
        {{ getFormattedDate(row.fechaDesde) }}
      </template>
      <template #cell-fechaHasta="{ row }">
        {{ getFormattedDate(row.fechaHasta) }}
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSuscripcion.idSuscripcion"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Plan -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Plan</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoSuscripcion.idPlan">
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="plan in plans"
                        :value="plan.idPlan"
                        :key="plan.idPlan"
                      >
                        {{ plan.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- ID Usuario -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID Usuario</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSuscripcion.idUsuario"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Forma de Pago -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Forma de Pago</label>
                  </div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoSuscripcion.idFormaPago">
                      <option disabled value="">Seleccione...</option>
                      <option
                        v-for="fp in formaPagos"
                        :value="fp.idFormaPago"
                        :key="fp.idFormaPago"
                      >
                        {{ fp.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Número -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Número</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSuscripcion.numero"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha de registro (solo lectura) -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha de Registro</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoSuscripcion.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha Desde -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha Desde</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoSuscripcion.fechaDesde"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Fecha Hasta -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Fecha Hasta</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoSuscripcion.fechaHasta"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarSuscripcion"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarSuscripcion"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import config          from "@/config";
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat      from "@/modules/dateFormat.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "SuscripcionList",
  components: { Layout, Footer, DataTable },

  props: {
    p_idEmpresa: { type: Number, required: true },
  },

  data() {
    return {
      suscripcions:    [],
      datoSuscripcion: {},
      nombreBusqueda:  "",
      titulo:          "",
      btnCrear:        false,
      btnEditar:       false,
      modalWindow:     true,
      plans:           [],
      formaPagos:      [],
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Usuario",      field: "usuarioNombre"  },
        // Fechas usan slots #cell-* para formateo
        { label: "F. Registro",  field: "fechaReg"       },
        { label: "Fecha Desde",  field: "fechaDesde"     },
        { label: "Fecha Hasta",  field: "fechaHasta"     },
        { label: "Forma Pago",   field: "formaPagoNombre"},
        { label: "Plan",         field: "planNombre"     },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
    this.fetchPlans();
    this.fetchFormaPagos();
  },

  methods: {
    // ── Utilidades ────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwsuscripcions/idempresa/" + this.p_idEmpresa)
        .then(r => { this.suscripcions = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar suscripciones:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwsuscripcions/nombre/" + nombre)
        .then(r => { this.suscripcions = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar suscripción:", e));
    },

    // ── Fetch auxiliares ──────────────────────────────────────
    fetchPlans() {
      fetch(config.apiBaseUrl + "/vwplans")
        .then(r => r.json())
        .then(data => { this.plans = data; })
        .catch(e => console.error("Error fetching plans:", e));
    },

    fetchFormaPagos() {
      fetch(config.apiBaseUrl + "/vwformapagos")
        .then(r => r.json())
        .then(data => { this.formaPagos = data; })
        .catch(e => console.error("Error fetching formaPagos:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoSuscripcion,
        ["idPlan", "idUsuario", "idFormaPago", "numero", "fechaDesde", "fechaHasta"],
        ["Plan", "ID Usuario", "Forma de Pago", "Número", "Fecha Desde", "Fecha Hasta"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarSuscripcion() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoSuscripcion.idUsuario = window.sessionStorage.getItem("idUsuario");
        this.datoSuscripcion.idEmpresa = this.p_idEmpresa;
        await api.post("/suscripcions", this.datoSuscripcion);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Suscripción creada exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarSuscripcion() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/suscripcions", this.datoSuscripcion);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Suscripción actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteSuscripcion(idSuscripcion) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar suscripción?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/suscripcions/" + idSuscripcion);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow     = true;
      this.datoSuscripcion = {};
      this.titulo          = "Crear Suscripción";
      this.btnCrear        = true;
      this.btnEditar       = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idSuscripcion) {
      this.modalWindow = true;
      this.titulo      = "Editar Suscripción";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp           = await api.get("/vwsuscripcions/" + idSuscripcion);
        this.datoSuscripcion = resp.data;
        // Normalizar fechas para input type="date"
        if (this.datoSuscripcion.fechaDesde)
          this.datoSuscripcion.fechaDesde = this.datoSuscripcion.fechaDesde.slice(0, 10);
        if (this.datoSuscripcion.fechaHasta)
          this.datoSuscripcion.fechaHasta = this.datoSuscripcion.fechaHasta.slice(0, 10);
      } catch (e) {
        console.error("Error al cargar suscripción:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idSuscripcion) {
      if (idSuscripcion != null) this.$router.push("/suscripcionform/" + idSuscripcion);
    },
  },
};
</script>